module.exports = __webpack_public_path__ + "static/media/selecta_acidofolico.eb33d33e.png";